import { useMemo } from "react";

/**
 * Translate a custom-table schema into the descriptor list consumed by
 * `CustomTableRowForm`. Sorts by the column's `position` so the form
 * matches the grid's column order.
 */
export const useDynamicFormFields = schema =>
  useMemo(() => {
    const columns = schema?.columns;
    if (!Array.isArray(columns) || columns.length === 0) return [];
    return [...columns]
      .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
      .map(column => ({
        name: column.field_id,
        label: column.display_name,
        type: column.type,
        required: !!column.is_required,
        unique: !!column.is_unique,
        choices: column.options?.choices ?? [],
        // Long text holds multi-paragraph content, so the form renders it as a
        // textarea; short_text stays a single-line input.
        multiline: column.type === "text",
        column,
      }));
  }, [schema]);

export default useDynamicFormFields;
